export class STpNameUpdateRequest {
  stpMainId!: number;
  stpName: string;
  stpNameBangla: string;
}
